import { useMemo } from "react";
import { Image } from "@gluestack-ui/themed";

import { ListTile } from "@repo/core/components/layout/ListTile";
import { TileLabel } from "@repo/core/components/layout/ListTile/types";

import GenericCardImage from "@repo/core/assets/images/generic-card.jpg";
import { ProductItemProps } from "./types";

export const ProductItem = ({
  id,
  strPlastico,
  strDescrProduto,
  strImagemProduto,
  isActive,
  isLoading,
  onPress
}: ProductItemProps) => {
  const maskedCardNumber = strPlastico?.trim().slice(-4);
  const labels = useMemo(() => {
    return [
      new TileLabel({
        text: strDescrProduto || "",
        fontColor: "$textLight900",
        fontWeight: 600,
        fontSize: "sm"
      }),
      new TileLabel({
        text: `**** **** **** ${maskedCardNumber}` || "",
        fontWeight: 500,
        fontSize: "xs"
      })
    ];
  }, [strDescrProduto, maskedCardNumber]);

  return (
    <ListTile
      id={id}
      onPress={onPress}
      labels={labels}
      isActive={isActive}
      isLoading={isLoading}
      leading={
        <Image
          w={"$24"}
          h={"$16"}
          alt="Avatar"
          source={
            strImagemProduto
              ? { uri: `data:image/jpeg;base64,${strImagemProduto}` }
              : GenericCardImage
          }
          borderColor={"$borderLight300"}
        />
      }
    />
  );
};
